//#region src/js/instagramFeed.js
function loadImage(image) {
	const src = image.getAttribute("data-image-src");
	if (src) {
		image.src = src;
		image.removeAttribute("data-image-src");
		image.classList.remove("opacity-0");
	}
}
var itemCount = document.querySelectorAll("[data-load-image]").length;
function updateItemCount() {
	document.querySelectorAll("#itemCount").forEach((item) => {
		item.textContent = `${itemCount}`;
	});
}
var observerOptions = {
	root: null,
	rootMargin: "0px",
	threshold: .5
};
function handleIntersection(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			const image = entry.target;
			loadImage(image);
			observer.unobserve(image);
		}
	});
}
var imageObserver = new IntersectionObserver(handleIntersection, observerOptions);
document.querySelectorAll("[data-load-image]").forEach((image) => {
	imageObserver.observe(image);
});
document.addEventListener("DOMContentLoaded", function() {
	updateItemCount();
});
document.addEventListener("DOMContentLoaded", function() {
	document.querySelector("[data-instagram-wrapper]").addEventListener("click", function(event) {
		if (event.target.classList.contains("modal-trigger")) openModal(event.target.getAttribute("data-src"));
	});
});
function openModal(imageUrl) {
	const modal = document.getElementById("instagramModal");
	const modalImage = document.getElementById("modalImage");
	modalImage.src = imageUrl;
	modal.style.display = "flex";
}
function closeModal() {
	const modal = document.getElementById("instagramModal");
	modal.style.display = "none";
}
document.querySelector("[data-close-modal]").addEventListener("click", function() {
	closeModal();
});
window.onclick = function(event) {
	const modal = document.getElementById("instagramModal");
	if (event.target === modal) modal.style.display = "none";
};
//#endregion
